/**
 * An API error carrying the HTTP status that produced it, so a caller can classify by status without an
 * `any` cast. Thrown by `ApiCallService` for the status ranges that have no more specific type — 417 and
 * 422 (both carrying the API's own user-facing message), the generic actionable 3xx-4xx, and 5xx.
 *
 * 409 is deliberately NOT one of these: it maps to {@link EntityLockedError} or {@link PullInProgressError},
 * which carry their own payloads. `isValidationWarning` marks the suppressible 422 case.
 */
export class StatusError extends Error {
    public status: number;
    public isValidationWarning?: boolean;

    constructor(message: string, status: number, isValidationWarning?: boolean) {
        super(message);
        this.name = 'StatusError';
        this.status = status;
        this.isValidationWarning = isValidationWarning;
        Object.setPrototypeOf(this, StatusError.prototype);
    }
}
